// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5861c462","455":"81c573f6","977":"61db292d"}[chunkId] + ".chunk.js";
};